import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ButtonsPopupModel } from '../../buttons-popup/buttons-popup.model';
import { Tab } from 'commons-lib';
import { ProductSearchModel, AddedProductModel } from './product-search.model';
import { EditFacModalService } from '../service/edit-fac-modal.service';
import { ButtonsPopupService } from '../../buttons-popup/service/buttons-popup.service';
import {
  AutocompleteProductResultsModel,
  AutocompleteProductAddressResultModel,
  AutocompleteProductModel } from '../../../../core/models/edit-fac-modal.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modal-product-search',
  templateUrl: './modal-product-search.component.html',
  styleUrls: ['./modal-product-search.component.scss']
})
export class ModalProductSearchComponent implements OnInit {

  private _show: boolean;
  @Input()
  set show(showInput: boolean) {
    this._show = showInput;
    this.productsToAddSession = [].concat(this.productsToAdd);
  }
  get show(): boolean { return this._show; }

  private _markets: number;
  @Input()
  set markets(opMkts: number) {
    this._markets = opMkts;
    this.tabsInit();
  }
  get markets(): number { return this._markets; }

  @Output() finish: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  public smWidgetsSubscription: Subscription;

  public showResults: boolean;
  public formLancamentos: FormGroup;
  public formProntos: FormGroup;
  public searchObj: ProductSearchModel;

  public autocomp: boolean;
  public autocompIdx = -1;

  public lastId: string;
  public searching: boolean;
  public addressObj: any = null;
  public currentPage = 0;
  public totalPages = 0;
  public totalResults = 0;
  public productsResult: any[] = [];
  public productsToAdd = [];
  public productsToAddSession = [];

  public autocompleteProducts: AutocompleteProductModel[];
  public autocompleteAddress: AutocompleteProductAddressResultModel[];
  public autocompTag: number;

  public readonly popupData: ButtonsPopupModel = {
    title: 'Atenção',
    description: 'Ao sair, as alterações serão perdidas.',
    buttons: [
      {
        btnType: 3,
        title: 'Cancelar',
        func: () => { }
      },
      {
        btnType: 1,
        title: 'Sair',
        func: () => {
          this.restartModal();
          this.finish.emit(this.productsToAdd);
          this.closeModal.emit(false);
        }
      }
    ]
  };

  public tabs = [
    new Tab(0, true, 'Lançamentos'),
    new Tab(1, false, 'Prontos')
  ];

  incrementList(): void {
    const bounding = document.getElementById(`last-product`).getBoundingClientRect();
    if (
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    ) {
      if (this.searching || this.currentPage === this.totalPages - 1) {
        return;
      }
      this.searchMore();
    }
  }

  constructor(private fb: FormBuilder,
              private facSvc: EditFacModalService,
              private btnService: ButtonsPopupService) { }

  ngOnInit(): void {
    this.smWidgetsSubscription = this.facSvc.getClearProductsModal().subscribe((clear: boolean) => {
      if (clear) {
        this.productsToAdd = [];
        this.restartModal();
      }
    });
    this.formsInit();
    this.autocompTag = Math.random();
  }

  restartModal(): void {
    this.formsInit();
    this.autocomp = false;
    this.showResults = false;
    this.searchObj = null;
    this.autocompleteProducts = null;
    this.autocompleteAddress = null;
    this.productsResult = [];
    this.productsToAddSession = [];
  }

  tabsInit(): void {
    if (this.markets === 3) {
      return;
    }
    if (this.markets === 2) {
      this.tabs[0].active = true;
      return;
    }
    if (this.markets === 1) {
      this.tabs[0].active = false;
      this.tabs[1].active = true;
      return;
    }
    this.closeSearchModal();
  }

  formsInit(): void {
    this.formLancamentos = this.fb.group({
      search: [null]
    });
    this.formProntos = this.fb.group({
      cod: [null],
      address: [null],
      num: [null]
    });
  }

  selectTab(tab: Tab): void {
    this.autocompIdx = -1;
    this.autocomp = false;
    this.tabs.forEach((item) => {
      if (item.id === tab.id) {
        item.active = true;
      } else {
        item.active = false;
      }
    });
  }

  searchProductInput(event: string | number): void {
    const searchTxt = String(event).trim();
    if (searchTxt.length > 2) {
      this.facSvc.autoCompleteProduct(searchTxt, 0, 7).subscribe((results: AutocompleteProductResultsModel) => {
        this.autocompleteProducts = results.products;
        this.autocomp = true;
      });
    } else {
      this.autocomp = false;
    }
  }

  searchAddressInput(event: string | number): void {
    this.addressObj = null;
    const searchTxt = String(event).trim();
    if (searchTxt.length > 2) {
      this.facSvc.autoCompleteProductAddress(searchTxt, 0, 7).subscribe((results: AutocompleteProductAddressResultModel[]) => {
        this.autocompleteAddress = results;
        this.autocomp = true;
      });
    } else {
      this.autocomp = false;
    }
  }

  pointerSelection(idx: number): void {
    this.autocompIdx = idx;
  }

  downList(event): void {
    if ((event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 27)) {
      switch (event.keyCode) {
        case 40:
          if (this.tabs[0].active) {
            if (this.autocompIdx < this.autocompleteProducts.length - 1) {
              this.autocompIdx += 1;
            }
          } else {
            if (this.autocompIdx < this.autocompleteAddress.length - 1) {
              this.autocompIdx += 1;
            }
          }
          break;
        case 38:
          if (this.autocompIdx > 0) {
            this.autocompIdx -= 1;
          }
          break;
        case 27:
          this.autocomp = false;
          return;
      }
      this.updateSearchInput();
    }
  }

  updateSearchInput(closeAutocomp?: boolean): void {
    if (this.tabs[0].active) {
      const searchTerm: string = this.autocompleteProducts[this.autocompIdx].name.replace(/<strong>/g, '').replace(/<\/strong>/g, '');
      this.formLancamentos.get('search').setValue(searchTerm);
    } else {
      // tslint:disable-next-line: max-line-length
      const searchTerm: string = this.autocompleteAddress[this.autocompIdx].formattedAddress.replace(/<strong>/g, '').replace(/<\/strong>/g, '');
      this.formProntos.get('address').setValue(searchTerm);
      this.addressObj = this.autocompleteAddress[this.autocompIdx].address;
      if (closeAutocomp) {
        this.autocomp = false;
        this.autocompIdx = -1;
      }
    }
  }

  closeAutocomplete(): void {
    this.autocomp = false;
  }

  searchLancamentos(idx?: number): void {
    if (!this.formLancamentos.get('search').value) {
      return;
    }
    if (idx >= 0) {
      const selectedProductName = this.autocompleteProducts[this.autocompIdx].name.replace(/<strong>/g, '').replace(/<\/strong>/g, '');
      this.addLancamentoAutocompSelect(selectedProductName);
    } else {
      const searchTerm: string = this.formLancamentos.get('search').value;
      this.facSvc.searchProductsRealEstateParent(searchTerm, this.currentPage, 20).subscribe((result: AutocompleteProductResultsModel) => {
        this.processProductsResult(result);
      });
    }
  }

  addLancamentoAutocompSelect(selectedProductName: string): void {
    this.facSvc.searchProductsRealEstateParent(selectedProductName, 0, 7).subscribe((result: AutocompleteProductResultsModel) => {
      if (result.products.length > 0) {
        this.productsResult = this.productsResult.concat(result.products);
        this.autocomp = false;
        if (this.productsResult.length > 1 && this.autocompIdx !== -1) {
          this.productsResult[this.autocompIdx].checked = true;
        } else {
          this.productsResult[0].checked = true;
        }
        this.autocompIdx = -1;
        this.finishAddingProducts();
      } else {
        this.processNoResultSearch();
      }
    });
  }

  searchProntos(): void {
    if ((!this.formProntos.get('cod').value && !this.formProntos.get('address').value)
    || (this.formProntos.get('cod').value && !this.formProntos.get('address').value && this.formProntos.get('num').value)) {
      return;
    }
    const addr = this.formProntos.get('address').value;
    const params = {
      cod: this.formProntos.get('cod').value,
      address: (addr && addr.length > 0) ? {address: [{ name: addr, type: 'address' }]} : null,
      num: this.formProntos.get('num').value
    };
    if (this.addressObj) {
      params.address.address = this.addressObj;
    }
    this.facSvc.searchProductsRealEstate(params, this.currentPage, 20).subscribe((result: AutocompleteProductResultsModel) => {
      this.processProductsResult(result);
    });
  }

  processProductsResult(result: any): void {
    if (result.products.length > 0) {
      this.totalResults = result.total_elements;
      this.totalPages = Math.ceil(result.total_elements / 20);
      this.productsResult = this.productsResult.concat(result.products);
      this.lastId = this.productsResult[this.productsResult.length - 1].id;
      this.showResults = true;
      this.autocomp = false;
      this.autocompIdx = -1;
      this.searching = false;
    } else {
      this.processNoResultSearch();
    }
  }

  processNoResultSearch(): void {
    this.totalResults = 0;
    this.productsResult = [];
    this.autocomp = false;
    this.autocompIdx = -1;
    this.searching = false;
    this.showResults = true;
  }

  searchMore(): void {
    this.searching = true;
    this.currentPage++;
    if (this.tabs[0].active) {
      this.searchLancamentos();
    } else {
      this.searchProntos();
    }
  }

  backToSearch(): void {
    this.formsInit();
    this.showResults = false;
    this.productsResult = [];
    this.searching = false;
    this.currentPage = 0;
  }

  checkItem(i: number, ev?: any): void {
    if (ev) {
      ev.stopPropagation();
    }
    this.productsResult[i].checked = !this.productsResult[i].checked;
  }

  verifyChecked(): boolean {
    let selected = false;
    this.productsResult.forEach(product => {
      if (product.checked) {
        selected = true;
      }
    });
    return selected;
  }

  removeItemToAdd(i: number) {
    this.productsToAdd.splice(i, 1);
  }

  removeSessionItemToAdd(j: number) {
    this.productsToAddSession.splice(j, 1);
  }

  finishAddingProducts(): void {
    if (!this.verifyChecked()) {
      return;
    }
    this.productsResult.forEach(result => {
      if (result.checked) {
        this.productsToAddSession.push(result);
      }
    });
    this.backToSearch();
  }

  finishModal(): void {
    const prods = this.processProducts();
    this.finish.emit(prods);
    this.closeSearchModal(true);
  }

  closeSearchModal(bypass?: boolean) {
    if (this.productsToAddSession.length !== this.productsToAdd.length && !bypass) {
      this.btnService.show(this.popupData);
    } else {
      this.closeModal.emit(false);
      this.restartModal();
    }
  }

  processProducts(): AddedProductModel[] {
    const prods: AddedProductModel[] = [];
    this.productsToAdd = this.productsToAddSession;
    this.productsToAdd.forEach(product => {
      prods.push({
        id: product.id,
        sku: product.id,
        name: product.name,
        offer_date: null
      });
    });
    return prods;
  }
}
